import { Navigate, Outlet } from "react-router-dom";
import { ProtectedRouteI } from "./index";

export default function AuthRoutes(props: ProtectedRouteI) {
  if (props.user === null) {
    return <Outlet />;
  }
  return <Navigate to="/home" replace />;
}
